import PropTypes from 'prop-types'
import { Route } from 'react-router-dom'
import { PERFILES_VENDEDOR } from '../../constants/perfiles'
import CuentaCorrienteMaestro from '../cuentaCorriente/CuentaCorrienteMaestro'
import RutaProtegidaPorPerfil from '../hoc/RutaProtegidaPorPerfil'
import Lista from '../lista/Lista'
import ListaVenta from '../lista/ListaVenta'
import DetallePreguntas from '../pages/preguntas/DetallePreguntas'
import PreguntasPublicaciones from '../pages/preguntas/PreguntasPublicaciones'
import Pedidos from '../pedidos/Pedidos'
import Presupuestos from '../presupuestos/Presupuestos'
import CargaMasivaDetalle from '../publicaciones/administrar/CargaMasivaDetalle'
import PublicacionDetalleAdmin from '../publicaciones/administrar/Detalle'
import PublicacionesAdmin from '../publicaciones/administrar/Publicaciones'
import PublicacionGrabada from '../publicar/PublicacionGrabada'
import Publicar from '../publicar/Publicar'
import ConvertirTiendaOficial from '../tiendasoficiales/convertirTiendaOficial/ConvertirTiendaOficial'
import GestionEnvio from '../ventas/GestionEnvio'

const proteger = (element) => (
  <RutaProtegidaPorPerfil perfilesPermitidos={PERFILES_VENDEDOR}>{element}</RutaProtegidaPorPerfil>
)

const VendedorRoutes = (props) => (
  <>
    <Route path="/Publicar" element={proteger(<Publicar />)} />
    <Route path="/PublicacionGrabada" element={proteger(<PublicacionGrabada />)} />
    <Route path="/Publicaciones/Administrar" element={proteger(<PublicacionesAdmin />)} />
    <Route
      path="/Publicaciones/Administrar/:idPublicacion"
      element={proteger(<PublicacionDetalleAdmin />)}
    />
    <Route path="/Publicaciones/CargaMasiva/:jobId" element={proteger(<CargaMasivaDetalle />)} />
    <Route path="/Presupuestos" element={proteger(<Presupuestos esVendedor={true} />)} />
    <Route path="/ConvertirTiendaOficial" element={proteger(<ConvertirTiendaOficial />)} />
    <Route
      path="/PreguntasVendedor"
      element={proteger(<PreguntasPublicaciones tipo={'vendedor'} />)}
    />
    <Route
      path="/PreguntasVendedor/:idPublicacion/:idVendedor"
      element={proteger(<DetallePreguntas {...props} tipo={'vendedor'} />)}
    />
    <Route path="/Ventas" element={proteger(<Pedidos esVentas={true} />)} />
    <Route path="/gestionEnvio/:idPedido" element={proteger(<GestionEnvio />)} />
    <Route path="/ListasEnvio" element={proteger(<Lista />)} />
    <Route path="/ListasVenta" element={proteger(<ListaVenta />)} />
    <Route path="/AdministrarCuentaCorriente" element={proteger(<CuentaCorrienteMaestro />)} />
  </>
)

VendedorRoutes.propTypes = {
  cambiarImagenPerfil: PropTypes.func
}

export default VendedorRoutes
